// extracted by mini-css-extract-plugin
module.exports = {"PurchaseBackToTop":"PurchaseBackToTop_PurchaseBackToTop__EUCI_"};